import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import HeaderImage from "../../assets/images/prospect-search-header.jpg";
import IndustryLeaders from "../../components/industry-leaders/industry-leaders";
import powerOfEmailMark from "../../assets/images/prospecting-search/power-of-email-marketing.png";
import advanceLead from "../../assets/images/prospecting-search/advance-lead.png";
import aiDriven from "../../assets/images/prospecting-search/AI-driven.png";
import seamlessEmail from "../../assets/images/prospecting-search/seamless-email-integration.png";
import oneClickEngagement from "../../assets/images/prospecting-search/oneClickEngagement.png";
import realTimeTracking from "../../assets/images/prospecting-search/real-time-tracking.png";
import Testimonials from "../../components/home/Testimonials";
import Cta from "../../components/cta/cta";

const BannerSection = () => {
  return (
    <>
      <div className="prospectingsearch-wrapper">
        <section className="pros-banner">
          <div className="max-container">
            <div className="padd-90">
              <div className="text-center banner-grp-sec">
                <h1 className="heading39px roboto-bold mb10 text-color-131415">
                  The Smarter Way to Find Your Next{" "}
                  <span className="text-primary-color">Big Client!</span>
                </h1>
                <p className="heading16px roboto-regular mb30">
                  Find the right prospects and engage them with targeted email
                  campaigns.
                </p>

                <ul className="btn-sec">
                  <li>
                    <NavLink
                      to={"/signup"}
                      className="common-btn-class main-btn-primary roboto-regular"
                    >
                      {" "}
                      Get Started
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <IndustryLeaders />

        <section>
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb40 heading29px text-center">
                Unlock the Power of Email Marketing
              </h2>
              <div className="grid-auto-fit align-items-center max-width950">
                <div className="company-search-etc">
                  <p className="heading16px roboto-regular mb20">
                    Our integrated email marketing tool works hand-in-hand with
                    the prospecting search feature to simplify your outreach
                    efforts. Whether it’s personalized drip campaigns or
                    large-scale email blasts, you’ll have everything you need to
                    nurture leads and close deals.
                  </p>

                  <p className="heading13px roboto-regular mb20">
                    <strong>Additional Features Include:</strong>
                  </p>

                  <ul class="points-ul">
                    <li class="heading16px roboto-regular">
                      Drag-and-drop email builder for quick campaign creation.
                    </li>
                    <li class="heading16px roboto-regular">
                      A/B testing for subject lines and content optimization.
                    </li>
                    <li class="heading16px roboto-regular">
                      Dynamic content personalization for higher engagement
                      rates.
                    </li>
                    <li class="heading16px roboto-regular">
                      GDPR-compliant tools to ensure data privacy.
                    </li>
                  </ul>
                </div>
                <div>
                  <img
                    src={powerOfEmailMark}
                    alt="Lead Capture"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="rec-three _border-top">
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb40 heading29px text-center">
                Why Choose Our Prospecting Search Tool?
              </h2>

              <div className="common-shadow common-white-box max-width950 mb20">
                <div className="left-right-comb">
                  <div>
                    <img
                      src={advanceLead}
                      className="img-responsive position-relative"
                      alt="Advanced Lead Discovery"
                    />
                  </div>
                  <div>
                    <h3 className="roboto-bold heading20px mb10">
                      Advanced Lead Discovery
                    </h3>
                    <p className="roboto-regular heading16px">
                      Tap into a vast database of prospects, filtered by
                      industry, location, job title, and more, ensuring you
                      target the right people.
                    </p>
                  </div>
                </div>
              </div>

              <div className="common-shadow common-white-box max-width950 mb20">
                <div className="left-right-comb">
                  <div>
                    <img
                      src={aiDriven}
                      className="img-responsive position-relative"
                      alt="AI-Driven Recommendations"
                    />
                  </div>
                  <div>
                    <h3 className="roboto-bold heading20px mb10">
                      AI-Driven Recommendations
                    </h3>
                    <p className="roboto-regular heading16px">
                      Leverage AI to identify prospects most likely to convert
                      based on their behavior, demographics, and engagement
                      history.
                    </p>
                  </div>
                </div>
              </div>

              <div className="common-shadow common-white-box max-width950 mb20">
                <div className="left-right-comb">
                  <div>
                    <img
                      src={seamlessEmail}
                      className="img-responsive position-relative"
                      alt="Seamless Email Integration"
                    />
                  </div>
                  <div>
                    <h3 className="roboto-bold heading20px mb10">
                      Seamless Email Integration
                    </h3>
                    <p className="roboto-regular heading16px">
                      Directly import your prospects into the email marketing
                      tool and start crafting personalized campaigns in minutes.
                    </p>
                  </div>
                </div>
              </div>

              <div className="common-shadow common-white-box max-width950 mb20">
                <div className="left-right-comb">
                  <div>
                    <img
                      src={oneClickEngagement}
                      className="img-responsive position-relative"
                      alt="One-Click Engagement"
                    />
                  </div>
                  <div>
                    <h3 className="roboto-bold heading20px mb10">
                      One-Click Engagement
                    </h3>
                    <p className="roboto-regular heading16px">
                      Send tailored emails or start automated sequences with a
                      single click, saving time and ensuring consistency.
                    </p>
                  </div>
                </div>
              </div>

              <div className="common-shadow common-white-box max-width950 mb20">
                <div className="left-right-comb">
                  <div>
                    <img
                      src={realTimeTracking}
                      className="img-responsive position-relative"
                      alt="Real-Time Tracking"
                    />
                  </div>
                  <div>
                    <h3 className="roboto-bold heading20px mb10">
                      Real-Time Tracking
                    </h3>
                    <p className="roboto-regular heading16px">
                      Monitor email opens, click-throughs, and replies to refine
                      your approach and enhance campaign effectiveness.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Cta
          heading="Start building your pipeline with smarter prospecting."
          firstCta="/signup"
          firstCtaText="Subscribe Now"
          secondCta="/contact-us"
          secondCtaText="Contact us"
        />

        <Testimonials />
      </div>
      {/* <section id="home" className="w3l-banner">
                <div className="banner-image">        </div>
                <div className="banner-content">
                    <div className="container pb-md-4">
                        <div className="row align-items-center py-4">
                            <div className="col-md-6 pr-lg-5 ">
                                <h3 className="mb-lg-4 mb-3 title">
                                    Find Prospects <span>with 95% data accuracy</span></h3>
                                <p className="mr-5">Discover qualified prospects in seconds with Beyond Leadz’s all-in-one prospecting tool.</p>
                                <div className="mt-md-5 mt-4 mb-lg-0 mb-4">
                                    <NavLink to={"/signup"} className="btn btn-style"> Start Free Trial</NavLink>
                                    <NavLink to={"/contact-us"} className="btn btn-style">Contact us</NavLink>
                                </div>
                            </div>
                            <div className="col-md-6 mt-md-0 mt-5 mb-lg-0 mb-5 right-banner-2 position-relative">
                                <div className="sub-banner-inner-image">
                                    <img src={HeaderImage} className="img-fluid radius-image-full position-relative" alt=" " />
                                </div>
                            </div>
                            <ul className="breadcrumbs-custom-path">
                                <li><NavLink to={'/'}>Home</NavLink></li>
                                <li className="active"><i className="fas fa-angle-right mx-2"></i>Executive Search / Company Search</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section> */}
    </>
  );
};
export default BannerSection;
